import {
  createPaginationLinkComponent,
  createPrevNextPageLinkComponent,
} from '@marketing-sites/ui'

const basePath = '/articles'

export const ArticlePaginationLink = createPaginationLinkComponent({
  basePath,
})

export const ArticlePaginationPrevLink = createPrevNextPageLinkComponent({
  linkText: '← Prev',
  basePath,
})
export const ArticlePaginationNextLink = createPrevNextPageLinkComponent({
  linkText: 'Next →',
  basePath,
})
